import axios from "axios";
import { SERVER_URL } from "../utils/constants";

export const fetchUserInfo = async (address: string) => {
  try {
    const res = await axios.get(`${SERVER_URL}/api/loadData?address=${address}`);
    return res.data;
  } catch (e) {
    return null;
  }

};